import React from "react";
import CreatePositionModal from "@/appComponents/Blocks/Modals/RecordEditorModal/CreatePositionModal";
import { usePlanManagerContext } from "@/providers/PlanManagerProvider";
import { GetWSMgr } from "@/Utils/StateLib";

export const PlanManagerCreatePositionModal = () => {
  const {
    recordEditorContextValue: {
      theData,
      showCreatePosition,
      showClonePosition,
      onSaveRecordEdit,
      onClosePositionEditor,
      parentPosition
    }
  } = usePlanManagerContext();

  const wsMgr = GetWSMgr();
  const manager = wsMgr?.GetPlanMgr();

  if (!showCreatePosition && !showClonePosition) return null;

  return (
    <CreatePositionModal
      theData={theData}
      showCreatePosition={showCreatePosition}
      showClonePosition={showClonePosition}
      onSaveRecordEdit={onSaveRecordEdit}
      onClosePositionEditor={onClosePositionEditor}
      parentPosition={parentPosition}
      manager={manager}
    />
  );
};

export default PlanManagerCreatePositionModal;
